import { ShoppingCart } from "lucide-react";

export default function FloatingCartAction({
  visible = true,
  label = "Add to Cart",
  disabled = false,
  onClick,
  testId = "floating-add-to-cart-btn",
}) {
  if (!visible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-40 w-[min(220px,calc(100vw-32px))] rounded-xl border border-gray-200 bg-white/95 p-2 shadow-[0_12px_32px_rgba(17,24,39,0.18)] backdrop-blur md:bottom-6 md:right-8 md:w-56">
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className="btn-gold flex w-full items-center justify-center gap-2 rounded-md px-4 py-3 text-sm font-semibold shadow-sm transition disabled:cursor-not-allowed disabled:opacity-50"
        data-testid={testId}
      >
        <ShoppingCart className="h-4 w-4" />
        {label}
      </button>
    </div>
  );
}
